// extracted by mini-css-extract-plugin
export default {"wrapper":"PurchaseBingoCards-module__wrapper","reloadButton":"PurchaseBingoCards-module__reloadButton"};